module.exports = __webpack_public_path__ + "img/diamond-1-no-shine.6e85b87e.png";